import { create } from 'zustand';

/**
 * Bildirim UI state'i. Veri React Query'de (['notifications']), bu store sadece
 * çekmece açık/kapalı + "en son görülen id" (badge hesabı için) tutar.
 *
 * Okundu durumu client-side: lastSeenId'den büyük id'ler "okunmamış". Çekmece
 * açılınca lastSeenId = max id yapılır → badge sıfırlanır. Tek istasyon kullanan
 * call center için yeterli; sunucu-side read state ileride eklenebilir.
 */

const LS_KEY = 'ccark.notif.lastSeenId';

function loadLastSeen(): number {
  if (typeof window === 'undefined') return 0;
  const v = Number(localStorage.getItem(LS_KEY));
  return Number.isFinite(v) ? v : 0;
}

interface NotifState {
  drawerOpen: boolean;
  lastSeenId: number;
  openDrawer: () => void;
  closeDrawer: () => void;
  /** Görülen en yüksek id'yi işaretle (badge sıfırlama). */
  markSeen: (maxId: number) => void;
}

export const useNotifications = create<NotifState>((set, get) => ({
  drawerOpen: false,
  lastSeenId: loadLastSeen(),
  openDrawer: () => set({ drawerOpen: true }),
  closeDrawer: () => set({ drawerOpen: false }),
  markSeen: (maxId) => {
    if (maxId <= get().lastSeenId) return;
    try { localStorage.setItem(LS_KEY, String(maxId)); } catch { /* */ }
    set({ lastSeenId: maxId });
  },
}));
